function validateEmail(email) {
   let re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if(re.test(email)) {
        return true
    } else {
        return false
    }
}

function validatePassword(password) {
    let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.*()_&])[A-Za-z\d@.*()_&]{8,}$/;
    if(re.test(password)) {
        return true
    } else {
        return false
    }
}

function validateURL(url) {
    
}

function validateMobileNumber(number) {
    return number.replace(/[^\+0-9]+/gi, "");
}

function validateUserName(username) {
    let re = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    if(re.test(username)){
      return true
    }  else {
        return false
    }
}

function sanitizeNumberInput(inputData) {
    return inputData.replace(/[^0-9.]+/gi, "");
}

function sanitizeInputFeild(inputData) {
    return inputData.replace(/[&/\\#+()$~%^'":*?<>{}]/g, "");
}

function validDomain(domain) {

}

export {
    validDomain,
    validateEmail,
    validateMobileNumber,
    validatePassword,
    validateUserName,
    validateURL,
    sanitizeInputFeild,
    sanitizeNumberInput,
}


// WEBPACK FOOTER //
// ./src/modules/common/utils/validateInput.js